export const ChevronDown = () => (
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    className="u-icon u-icon--utility-chevron-down"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.57275 9.97222C8.4263 10.1187 8.1889 10.1187 8.04245 9.97222L4.21921 6.14897C4.07276 6.00252 4.07276 5.76512 4.21921 5.61867L4.39599 5.44187C4.54243 5.29542 4.77987 5.29542 4.92632 5.44187L8.3076 8.82317L11.6889 5.44187C11.8353 5.29542 12.0727 5.29542 12.2192 5.44187L12.396 5.61867C12.5424 5.76512 12.5424 6.00252 12.396 6.14897L8.57275 9.97222Z"
      fill="currentColor"
    />
  </svg>
);
